module.exports = __webpack_public_path__ + "img/apple.0fd42ac0.svg";